module.exports = __webpack_public_path__ + "img/Združene države Amerike.4e396d4b.png";